import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import productImg from "../../img/product_img_landing/lsfg_navi.jpg";

const LSFG_Navi = () => {
  return (
    <div>
      <Navbar />
      <div className="container mt-5 pt-5">
        <div className="row mt-4">
          <div className="col-lg-6 mb-4">
            <img
              src={productImg}
              alt="LSFG-NAVI Laser Speckle Flowgraphy"
              className="img-fluid"
              style={{ borderRadius: "10px" }}
            />
          </div>
          <div className="col-lg-6">
            <p className="text-muted mb-1">Softcare Co. Ltd., Japan</p>
            <h2 className="fw-bold">Laser Speckle Flowgraphy LSFG-NAVI</h2>
            <h5 className="text-danger mb-3">Model: LSFG-NAVI NM</h5>
            <div className="dash mb-3"></div>
            <p className="lh-lg">
              LSFG-NAVI NM (Laser Speckle Flowgraphy - NAVI Neuro-Microvascular) is a
              clinically approved, non-contact system that visualizes and quantifies retinal
              and optic nerve head blood flow in humans.
            </p>
            <p className="lh-lg">
              It leverages the 830 nm diode laser and a CC-camera fundus imaging module to
              obtain dynamic blood flow maps synchronized with the cardiac cycle. Blood flow
              is expressed as Mean Blur Rate (MBR), a relative index — ideal for tracking
              hemodynamic responses before/after treatments or surgery, without requiring
              pupil dilation or contrast agents.
            </p>
            <ul className="mt-3 lh-lg">
              <li><strong>Generic Name:</strong> Ophthalmic Camera Device / Optical Coherence Tomography</li>
              <li><strong>Risk Class:</strong> Class B</li>
              <li><strong>Manufacturer:</strong> Softcare Co. Ltd., Japan</li>
              <li><strong>Importer:</strong> Aura Medical Limited</li>
              <li><strong>510(k) Number:</strong> K153239</li>
            </ul>
          </div>
        </div>

        {/* Specifications */}
        <div className="mt-5 mb-5">
          <h3 className="fw-bold mb-3">Specifications</h3>
          <div className="dash1 mb-4"></div>
          <table className="table table-bordered border-table">
            <tbody>
              <tr>
                <td><strong>Principle</strong></td>
                <td>Laser Speckle Flowgraphy (LSFG)</td>
              </tr>
              <tr>
                <td><strong>Power</strong></td>
                <td>AC120V, 60Hz (AC adapter: PMP90-13)</td>
              </tr>
              <tr>
                <td><strong>Light Source Type</strong></td>
                <td>Laser Diode</td>
              </tr>
              <tr>
                <td><strong>Wave Length</strong></td>
                <td>830nm</td>
              </tr>
              <tr>
                <td><strong>Laser Class</strong></td>
                <td>1 (Based on IEC60825-1:2007)</td>
              </tr>
              <tr>
                <td><strong>Spot Size on Retina</strong></td>
                <td>Area including macular and ONH of subjective eye with normal diopter</td>
              </tr>
              <tr>
                <td><strong>View Angle</strong></td>
                <td>Maximum 21 degrees</td>
              </tr>
              <tr>
                <td><strong>Resolution</strong></td>
                <td>750W × 360H Pixel</td>
              </tr>
              <tr>
                <td><strong>Time Resolution</strong></td>
                <td>30 Frame/sec</td>
              </tr>
              <tr>
                <td><strong>Safety Standard</strong></td>
                <td>IEC60601-1, IEC60601-1-2</td>
              </tr>
              <tr>
                <td><strong>Size</strong></td>
                <td>About 40 x 50 x 40 cm</td>
              </tr>
              <tr>
                <td><strong>Weight</strong></td>
                <td>About 18 kg</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LSFG_Navi;
